export const APP_NAME = "Chat with GPT";